module.exports = __webpack_public_path__ + "img/16.07b2d870.png";